import VueRouter from "vue-router";
import { getToken, getTokenNew } from "@/utils/userStorage";
import store from "@/store/index";
import { MessageBox } from "element-ui";

export function createTokenCheckGuard(router: VueRouter): void {
  router.beforeEach(async (to, from, next) => {
    const isNew = (to as any).meta.isNew;
    if (isNew) {
      store.dispatch("UPDATE_VERSION", "v2");
    } else {
      store.dispatch("UPDATE_VERSION", "v1");
    }
    if (store.state.isBudgetSystem === null) {
      store.commit("SET_isBudgetSystem", location.href.includes("budget-business"));
    }
    if (!store.state.searchItem_Inited) {
      await store.dispatch("GET_searchItem");
    }

    if ((to as any).meta.needLogin) {
      let token = isNew ? getTokenNew() : getToken();
      const urlToken = new URLSearchParams(location.search).get("token");
      if (urlToken) {
        // console.log("tokenCheckGuard.ts 从路由取token，app的新建社区用到");
        token = urlToken;
      }
      if (store.state.isBudgetSystem && !(to as any).meta.isBudgetSystemWhiteList) {
        MessageBox.alert("暂无访问权限", "提示", { type: "warning" });
        next(false);

        return false;
      }
      if (token) {
        if (isNew) {
          if (store.state.comtyIdNew && store.state.comtyIdNew !== "undefined") {
            if (!(store.state.comtyInfoNew && store.state.comtyInfoNew.communityId)) {
              try {
                console.log(store);
                await store.dispatch("UPDATE_COMTYINFONEW", store.state.comtyIdNew);
              } catch (error) {
                console.log(error);
              }
            }
            const ignorePermission = !!to.meta?.ignorePermission;
            if (!ignorePermission) {
              if (store.state.isEverSetStateGeneService === 0) {
                await store.dispatch("UPDATE_isEverSetStateGeneService");
              }
              if (!store.state.permissionListNew) {
                await store.dispatch("GET_PERMISSIONLISTNEW");
              }
              store.dispatch("UPDATE_MESSAGENUMBERNEW", store.state.comtyIdNew);
              store.dispatch("UPDATE_TABNUM", store.state.comtyIdNew);
            }
          }
          next();
          return true;
        } else {
          if (store.state.bId && !(store.state.orgInfo && store.state.orgInfo.id)) {
            //2022年2月22日12:44:32 更新机构接口
            await store.dispatch("GET_ORGINFO");
          }
          if (!(store.state.userInfo && store.state.userInfo.id)) {
            // 2022年2月22日12:44:00  更新用户接口
            await store.dispatch("UPDATE_USERINFO", token);
          }
          if (store.state.comtyId && store.state.comtyId !== "undefined") {
            if (!(store.state.comtyInfo && store.state.comtyInfo.communityId)) {
              try {
                console.log(store);
                await store.dispatch("UPDATE_COMTYINFO", store.state.comtyId);
              } catch (error) {
                console.log(error);
              }
            }
            if (!store.state.permissionList) {
              await store.dispatch("GET_PERMISSIONLIST");
            }
            if (!(store.state.comtyConfig && store.state.comtyConfig.settledAudit)) {
              store.dispatch("UPDATE_COMTYCONFIG", store.state.comtyId);
            }
            if (store.state.messageNumber == -1) {
              store.dispatch("UPDATE_MESSAGENUMBER", store.state.comtyId);
            }
          }
          // if (to.name) {
          //   store.commit("SET_CurrentRouteName", to.name);
          //   await store.dispatch("GET_PagePermissionList");
          // }
          next();
          return true;
        }
      } else {
        if (isNew) {
          if (window.location.pathname != "/newCommunity/login") {
            window.location.replace("/newCommunity/login");
          }
          return false;
        } else {
          if (window.location.pathname != "/login") {
            window.location.replace("/login");
          }
          return false;
        }
      }
    }
    next();
    return true;
  });
}
